var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEyeVisible = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 13",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  transform: "translate(0 1)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 10,
  cy: 5.833,
  r: 2.917
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.48 5.56C18.51 4.46 14.635.417 10 .417 5.365.417 1.49 4.46.52 5.56a.418.418 0 0 0 0 .547c.97 1.1 4.845 5.143 9.48 5.143 4.635 0 8.51-4.043 9.48-5.143a.418.418 0 0 0 0-.547z"
}))));
export { SvgEyeVisible as ReactComponent };
export default __webpack_public_path__ + "assets/images/eye-visible.svg";